import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DragulaModule} from 'ng2-dragula';
import {LayoutService} from '@ngmedax/layout';
import {Translatable} from '@ngmedax/translation';
import {MasterDataModule} from '@ngmedax/master-data';

import {NAVIGATION} from './settings-client-custom.navigation';
import {SettingsClientCustomService} from './services/settings-client-custom.service';
import {SettingsClientCustomCrudService} from './services/settings-client-custom-crud.service';
import {SettingsClientCustomGridComponent} from './components/grid/settings-client-custom-grid.component';
import {SettingsClientCustomCrudComponent} from './components/crud/settings-client-custom-crud.component';
import {MasterDataLayoutEditorComponent} from './components/master-data-layout-editor/master-data-layout-editor.component';
import {GridRendererEditorComponent} from './components/grid-renderer-editor/grid-renderer-editor.component';
import {TRANSLATION_DEFAULT_SCOPE} from '../../constants';
import {KEYS} from '../../translation-keys';
import {TruncatePipe} from './pipes/truncate.pipe';
import {DatexPipe} from './pipes/datex.pipe';
import {routing} from './settings-client-custom.routing';

export interface SettingsClientCustomModule extends Translatable {}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    DragulaModule.forRoot(),
    MasterDataModule,
    routing
  ],
  declarations: [
    SettingsClientCustomGridComponent,
    SettingsClientCustomCrudComponent,
    MasterDataLayoutEditorComponent,
    GridRendererEditorComponent,
    TruncatePipe,
    DatexPipe
  ],
  exports: [
    SettingsClientCustomGridComponent,
    SettingsClientCustomCrudComponent,
    MasterDataLayoutEditorComponent,
    GridRendererEditorComponent
  ],
  entryComponents: [
    SettingsClientCustomCrudComponent
  ],
  providers: [
    SettingsClientCustomCrudService,
    SettingsClientCustomService
  ]
})

@Translatable({scope: TRANSLATION_DEFAULT_SCOPE, keys: KEYS})
export class SettingsClientCustomModule {
  constructor(layoutService: LayoutService) {
    layoutService.addMenuEntry(NAVIGATION);
  }
}
